"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inverseLookup = exports.lookup = void 0;
const development_1 = __importDefault(require("./development"));
const production_1 = __importDefault(require("./production"));
const environment = process.env.ENVIRONMENT || 'development';
const loadValues = () => {
    if (environment === 'production') {
        return production_1.default;
    }
    else {
        return development_1.default;
    }
};
const lookup = (numericId) => {
    const data = loadValues();
    return data[numericId];
};
exports.lookup = lookup;
const inverseLookup = (legacyId) => {
    const data = loadValues();
    const found = Object.keys(data).find((key) => data[parseInt(key, 10)] === legacyId);
    if (found) {
        return parseInt(found, 10);
    }
    return undefined;
};
exports.inverseLookup = inverseLookup;
